import ar from "./ar.json";
import en from "./en.json";

export function lang(value){
  localStorage.setItem('_locale_', value);
}

export default function locale(key="test", domain = "default"){
  // TODO: if key doesn't exist sent to store in .json
  const lang = localStorage.getItem('_locale_');
  let langjson = {};
  langjson = en;
  if(lang == "ar"){
    langjson = ar;
  }
  return langjson[domain][key];
}